export default {
    // serverIP: '101.43.196.179',
    // serverIP: '43.143.220.47',
    // serverIP: '192.168.43.235',
    serverIP: '43.140.211.42',
    // serverIP: '49.232.60.206',
    // serverIP: 'localhost',
    serverHost: 8081,
}
